import { LIST_REQUEST, LIST_ERROR, RECIEVE_LIST, SET_LIST, SET_LIST_URL } from "../action_types";
import store from "../store";
import Axios from "axios";

const listRequest = () => ({
    type: LIST_REQUEST,
});

const listError = (message) => ({
    type: LIST_ERROR,
    message,
});

const recieveList = (vendorList) => ({
    type: RECIEVE_LIST,
    vendorList,
});

const setList = (list) => ({
    type: SET_LIST,
    list,
});

const setListUrl = (url) => ({
    type: SET_LIST_URL,
    url,
});

export const fetchList = () => (dispatch, getState) => {
    dispatch(listRequest());
    return Axios.get(getState().vendorListUrl)
        .then((response) => {
            dispatch(recieveList());
            dispatch(setList(response.data));
        })
        .catch((err) => {
            console.log(err)
            return;
        });
};

export const boundListRequest = () => store.dispatch(listRequest());
export const boundListError = (message) => store.dispatch(listError(message));
export const boundRecieveList = (response) => store.dispatch(recieveList(response));
export const boundSetList = (list) => store.dispatch(setList(list));
export const boundSetListUrl = (url) => store.dispatch(setListUrl(url));
export const boundFetchList = () => store.dispatch(fetchList());